// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Creator } from "./Creator";
import {
  CreatorFromJSON,
  CreatorFromJSONTyped,
  CreatorToJSON,
  CreatorToJSONTyped,
} from "./Creator";

/**
 * Message creation model
 *
 * creator: Optionally when user authorizes with an API key.
 * @export
 * @interface MessageCreate
 */
export interface MessageCreate {
  /**
   *
   */
  body: string;
  /**
   *
   */
  creator?: Creator | null;
}

/**
 * Check if a given object implements the MessageCreate interface.
 */
export function instanceOfMessageCreate(value: object): value is MessageCreate {
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function MessageCreateFromJSON(json: any): MessageCreate {
  return MessageCreateFromJSONTyped(json, false);
}

export function MessageCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageCreate {
  if (json == null) {
    return json;
  }
  return {
    body: json["body"],
    creator:
      json["creator"] === undefined
        ? undefined
        : json["creator"] === null
        ? null
        : CreatorFromJSON(json["creator"]),
  };
}

export function MessageCreateToJSON(json: any): MessageCreate {
  return MessageCreateToJSONTyped(json, false);
}

export function MessageCreateToJSONTyped(
  value?: MessageCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    body: value["body"],
    creator: CreatorToJSON(value["creator"]),
  };
}
